import ReactMarkdown from 'react-markdown'
import logo from './../images/logo.svg'

import boltorange from './../sprites/boltorange-250-min.png'
import boltred from './../sprites/boltred-250-min.png'
import boltyellow from './../sprites/boltyellow-250-min.png'

import spritegrey from './../sprites/virusunknown-250-min.png'

import spriteship from './../sprites/ship-min.png'
import spriteorange from './../sprites/virusorange-250-min.png'
import spriteyellow from './../sprites/virusyellow-250-min.png'
import spritered from './../sprites/virusred-250-min.png'


function StartScreen (props) {

  const {messagePool, startGame} = props

  

  return (
   <> 
         <h1 className="title">BATTLING THE BUGS</h1>
         <div id="instructions" >
         <p style={{
      fontWeight: 700,
      marginTop: "0.25em",
      marginBottom: "0.5em"

    }}>INSTRUCTIONS</p>
         <div style={{
           height: "3em",
           width: "100%",
           position: "relative"
         }}>
                    <div style={{
           height: "3em",
           position: "absolute",
           top: 0,
           left: "25%"
         }}>

           <img style={{
           height: "100%",
           transform: "rotate(180deg)"
         }} src={spriteship} alt="" />

</div>

         <div style={{
           height: "3em",
           display: "flex",
           flexDirection: "column",
           justifyContent: "center"


         }}>
         <img style={{
          height: "50%",
          objectFit: "contain",
          paddingRight: "12%",
          transform: "rotate(180deg)",
        }} src={boltyellow} alt="" />
        
        </div>
        <div style={{
           height: "3em",
           position: "absolute",
           top: 0,
           right: "25%"
         }}>

          <img style={{
          height: "100%"
        
        }} src={spriteyellow} alt="" />
                </div>

        </div>
 
   {String(messagePool.introMessages[0][0]).split("<<").map ( (p, i) =>
    

p.trim().length > 0 ? 
       <div key={i}> {i === 2 ? 
        <div style={{
          height: "3em",
          width: "70%",
          left: "15%",
          position: "relative"
        }}>
                   <div style={{
          height: "3em",
          position: "absolute",
          top: 0,
          left: "15%"
        }}>

          <img style={{
          height: "100%",
        }} src={spriteyellow} alt="" />
        <img style={{
          position: "relative",
          top: "-25%",
          left: "15%",
          height: "50%",
        }} src={boltyellow} alt="" />

</div>



<div style={{
          height: "3em",
          position: "absolute",
          top: 0,
          right: "15%"
        }}>

          <img style={{
          height: "100%",
        }} src={spritered} alt="" />
<img style={{
          position: "relative",
          top: "-25%",
          left: "15%",
          height: "50%",
        }} src={boltred} alt="" />
</div>
</div>

       
       
       : ""}

{i === 4 ? 
        <div style={{
          height: "3em",
          width: "100%",
          position: "relative"
        }}>
                  <div style={{
          height: "3em",
          margin: "auto"
        }}>

          <img style={{
          height: "100%",
        }} src={spriteorange} alt="" />
        <img style={{
          position: "relative",
          top: "-25%",
          left: "2%",
          height: "50%",
          transform: 'rotate(180deg)'
        }} src={boltorange} alt="" />

</div>


</div>

       
       : ""}
{i === 6 ? 
        <div style={{
          height: "3em",
          width: "100%",
          position: "relative"
        }}>
                   <div style={{
          height: "3em",
          margin: "auto"
        }}>

          <img style={{
          height: "100%",
        }} src={spritegrey} alt="" />
        

</div>


</div>

       
       : ""}


    <ReactMarkdown>{p}</ReactMarkdown>
    </div>
   : "")
}

</div>
    <div onClick={startGame} className="startButton" ><span>START</span></div>
          
    <div id="logo" style={{
   marginTop: "0.5em",
   width: "100%",
   zIndex: -1,
    backgroundImage: `url(${logo})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center"
  }}></div>
    </>
   
  )
}

export default StartScreen